"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7.59 13.22a.49.49 0 0 0 -.49-.49h-2a.49.49 0 0 0 -.49.49.48.48 0 0 0 .49.49h2a.48.48 0 0 0 .49-.49z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 17.63a.49.49 0 0 0 -.49.49v2a.49.49 0 0 0 1 0v-2a.49.49 0 0 0 -.51-.49z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8.22 10.14a.5.5 0 0 0 .7 0 .49.49 0 0 0 0-.69l-1.47-1.45a.5.5 0 0 0 -.7 0 .49.49 0 0 0 0 .69z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8.22 16.31-1.47 1.46a.49.49 0 0 0 .7.7l1.47-1.47a.49.49 0 0 0 -.7-.69z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.77 16.31a.49.49 0 0 0 -.69.69l1.47 1.47a.49.49 0 0 0 .69 0 .47.47 0 0 0 0-.69z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m19.71 5.71.86-.85.39.38a.47.47 0 0 0 .69 0 .49.49 0 0 0 0-.69l-1.47-1.47a.49.49 0 0 0 -.69.69l.39.39-.88.89a10.75 10.75 0 0 0 -6.51-2.58v-1.47h.51a.49.49 0 1 0 0-1h-2a.49.49 0 0 0 0 1h.49v1.47a10.79 10.79 0 1 0 8.2 3.24zm-2.47 3-1.47 1.47a.49.49 0 0 1 -.69-.69l1.47-1.49a.49.49 0 0 1 .69 0 .47.47 0 0 1 0 .67zm-5.24 14.29a9.79 9.79 0 0 1 -.49-19.57v9.77a.48.48 0 0 0 .49.49h9.77a9.8 9.8 0 0 1 -9.77 9.31z"
  })));
};

exports["default"] = _default;